import {
  Modal,
  Table,
  Button,
  Text,
  Badge,
  Group,
  Stack,
  Box,
  Card,
  Avatar,
  Flex,
  NumberFormatter,
  Tooltip,
} from "@mantine/core";
import {
  IconBuildingWarehouse,
  IconMapPin,
  IconPackage,
  IconCheck,
} from "@tabler/icons-react";

// Props type (có thể tách ra file types nếu lớn hơn)
interface Props {
  opened: boolean;
  setOpened: (opened: boolean) => void;
  selectedWarehouse: any;
  setSelectedWarehouse: (warehouse: any) => void;
  warehouseList: any[]; // hoặc bạn có thể define rõ kiểu hơn nếu cần
}

export default function WarehouseSelector({
  opened,
  setOpened,
  selectedWarehouse,
  setSelectedWarehouse,
  warehouseList,
}: Props) {
  const handleSelect = (warehouse: any) => {
    setSelectedWarehouse(warehouse);
    setOpened(false);
  };

  return (
    <Modal
      opened={opened}
      onClose={() => setOpened(false)}
      title={
        <Group gap="sm">
          <Avatar size="sm" color="blue" variant="light">
            <IconBuildingWarehouse size={16} />
          </Avatar>
          <Text size="lg" fw={600}>
            Chọn kho chứa hàng
          </Text>
        </Group>
      }
      size="xl"
      radius="md"
      padding="xl"
      styles={{
        header: {
          backgroundColor: "#f8f9fa",
          borderBottom: "1px solid #e9ecef",
          marginBottom: "1rem",
        },
        body: {
          padding: 0,
        },
      }}
    >
      <Box p="md">
        {warehouseList.length === 0 ? (
          <Card withBorder radius="md" p="xl">
            <Stack align="center" gap="md">
              <Avatar size="xl" color="gray" variant="light">
                <IconBuildingWarehouse size={32} />
              </Avatar>
              <Text c="dimmed" ta="center">
                Không có kho hàng nào khả dụng
              </Text>
            </Stack>
          </Card>
        ) : (
          <Table.ScrollContainer minWidth={600}>
            <Table
              striped
              highlightOnHover
              withTableBorder
              withColumnBorders={false}
              styles={{
                th: {
                  backgroundColor: "#f1f3f4",
                  fontWeight: 600,
                  fontSize: "13px",
                  padding: "6px 8px",
                  color: "#495057",
                  whiteSpace: "nowrap",
                },
                td: {
                  padding: "6px 8px",
                  verticalAlign: "middle",
                  fontSize: "13px",
                  whiteSpace: "nowrap",
                },
              }}
            >
              <Table.Thead>
                {" "}
                <Table.Tr>
                  <Table.Th>
                    <Group gap="xs">
                      <IconMapPin size={16} />
                      <Text>Chi nhánh</Text>
                    </Group>
                  </Table.Th>
                  <Table.Th>
                    <Group gap="xs">
                      <IconBuildingWarehouse size={16} />
                      <Text>Tên kho</Text>
                    </Group>
                  </Table.Th>
                  <Table.Th>
                    <Text>Mã kho</Text>
                  </Table.Th>
                  <Table.Th>
                    <Group gap="xs">
                      <IconPackage size={16} />
                      <Text>SL tồn</Text>
                    </Group>
                  </Table.Th>
                  <Table.Th style={{ width: 120 }}>
                    <Text ta="center">Thao tác</Text>
                  </Table.Th>
                </Table.Tr>
              </Table.Thead>
              <Table.Tbody>
                {warehouseList.map((wh) => (
                  <Table.Tr
                    key={wh.subInvId}
                    style={{
                      backgroundColor:
                        selectedWarehouse?.subInvId === wh.subInvId
                          ? "#e3f2fd"
                          : undefined,
                    }}
                  >
                    {" "}
                    <Table.Td>
                      <Group gap="sm" wrap="nowrap">
                        <Avatar size="sm" color="blue" variant="light">
                          <IconMapPin size={14} />
                        </Avatar>
                        <Box style={{ minWidth: 0, flex: 1 }}>
                          <Text
                            fw={500}
                            size="sm"
                            truncate="end"
                            style={{ whiteSpace: "nowrap" }}
                          >
                            {wh.branchName}
                          </Text>
                        </Box>
                      </Group>
                    </Table.Td>
                    <Table.Td>
                      <Group gap="sm" wrap="nowrap">
                        <Avatar size="sm" color="teal" variant="light">
                          <IconBuildingWarehouse size={14} />
                        </Avatar>
                        <Box style={{ minWidth: 0, flex: 1 }}>
                          <Text
                            fw={500}
                            size="sm"
                            truncate="end"
                            style={{ whiteSpace: "nowrap" }}
                          >
                            {wh.subInvName}
                          </Text>
                        </Box>
                      </Group>
                    </Table.Td>{" "}
                    <Table.Td>
                      <Text fw={500} size="sm" style={{ whiteSpace: "nowrap" }}>
                        {wh.subInvCode}
                      </Text>
                    </Table.Td>
                    <Table.Td>
                      <Badge
                        variant="light"
                        color={wh.onhandQuantity > 0 ? "green" : "red"}
                        size="lg"
                        radius="md"
                      >
                        <NumberFormatter
                          value={wh.onhandQuantity}
                          thousandSeparator="."
                          decimalSeparator=","
                        />
                      </Badge>
                    </Table.Td>
                    <Table.Td>
                      <Flex justify="center">
                        <Tooltip label="Chọn kho này" position="top">
                          <Button
                            size="sm"
                            variant="gradient"
                            gradient={{ from: "blue", to: "cyan" }}
                            leftSection={<IconCheck size={16} />}
                            onClick={() => handleSelect(wh)}
                            radius="md"
                            disabled={wh.onhandQuantity <= 0}
                          >
                            Chọn
                          </Button>
                        </Tooltip>
                      </Flex>
                    </Table.Td>
                  </Table.Tr>
                ))}
              </Table.Tbody>
            </Table>
          </Table.ScrollContainer>
        )}
      </Box>
    </Modal>
  );
}
